import isIBanner from './node/isIBanner';
import isICard from './node/isICard';
import isICarousel from './node/isICarousel';
import isIContainer from './node/isIContainer';
import isILink from './node/isILink';
import isIList from './node/isIList';
import isIModal from './node/isIModal';
import isIPadding from './node/isIPadding';
import isIScrollable from './node/isIScrollable';
import isISpan from './node/isISpan';
export function getChildren(node) {
    const children = [];
    const mutable = node;
    if ((isIBanner(mutable) || isICard(mutable) || isICarousel(mutable) || isIContainer(mutable) || isIList(mutable) || isIScrollable(mutable) || isISpan(mutable)) && mutable.children) {
        children.push(...mutable.children);
    } else if (isIModal(mutable)) {
        children.push(mutable.content, mutable.modal);
    } else if (isIPadding(mutable) || isILink(mutable)) {
        children.push(mutable.node);
    }
    return children.filter(n => !!n);
}
export default getChildren;    //# sourceMappingURL=getChildren.js.map
